<template>
	<div class="header">
		<div class="content">
			<a href="/">
				<img class="logo" src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P8.png" >
			</a>
			<div class="list flex">
				<div @click="toPage(item.url)" :class="{on:active==index}" v-for="(item,index) in Navigation" :key="index">{{item.name}}</div>
			</div>
			<div class="Hotline flex">
				<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P2.png" >
				服务热线：400-162-5566
				<a href="https://saas.shangzhijia.cn" target="_blank" class="SignIn">
					企业登录
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "header",
		props:{
			active: Number
		},
		data() {
			return {
				Navigation:[
					{
						name:'首页',
						url:'/'
					},
					{
						name:'找工作',
						url:'./jobHunting'
					},
					{
						name:'招商加盟',
						url:'/construction'
					},
					{
						name:'关于我们',
						url:'./aboutUs'
					}
				]
			}
		},
		mounted() {},
		methods:{
			toPage(url){
				this.$router.push(url)
			}
		}
	}
</script>

<style lang="less" scoped>
	.header{
		.on{
			color: #00BCD4!important;
			font-weight: bold;
			position: relative;
		}
		.on:before {
			content: "";
			display: block;
			position: absolute;
			bottom: -20px;
			left: 50%;
			transform: translate(-50%, 0);
			width: 60px;
			height: 2px;
			background: #00BCD4;
		}
		.Hotline{
			.SignIn:hover{
				border: 1px solid #00BCD4;
				text-decoration: none;
			}
			.SignIn{
				width: 80px;
				height: 30px;
				border: 1px solid #999999;
				border-radius: 15px;
				font-size: 14px;
				text-align: center;
				line-height: 30px;
				margin-left: 25px;
			}
			img{
				width: 12px;
				height: 16px;
				margin-right: 9px;
				margin-top: 3px;
			}
			color: #666666;
			font-size: 16px;
			margin-left: 190px;
		}
		.list{
			div:hover{
				color: #00BCD4;
			}
			div{
				cursor: pointer;
			}
			width: 444px;
			margin-left: 90px;
			font-size: 16px;
			color: #333333;
		}
		.logo{
			width: 152px;
			height: 40px;
		}
		.content{
			width: 1200px;
			margin: auto;
			display: flex;
			align-items: center;
		}
		background-color: #fff;
		padding: 25px 0;
		width: 100%;
	}
	
</style>

